module.exports = __webpack_public_path__ + "static/media/bq_sunken_ship.42fa6506.png";